import { registrationApi } from '../registrationApi';
import type {
  GenderType,
  RaceType,
  MaritalStatusType,
  AddressTypeOption,
} from '../types/dimensionTypes';

const dimensionEndpoints = registrationApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get gender types
    // GET /gender-types
    getGenderTypes: builder.query<GenderType[], void>({
      query: () => '/gender-types',
    }),

    // Get race types
    // GET /race-types
    getRaceTypes: builder.query<RaceType[], void>({
      query: () => '/race-types',
    }),

    // Get marital status types
    // GET /marital-status-types
    getMaritalStatusTypes: builder.query<MaritalStatusType[], void>({
      query: () => '/marital-status-types',
    }),

    // Get address types
    // GET /address-types
    getAddressTypes: builder.query<AddressTypeOption[], void>({
      query: () => '/address-types',
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetGenderTypesQuery,
  useGetRaceTypesQuery,
  useGetMaritalStatusTypesQuery,
  useGetAddressTypesQuery,
} = dimensionEndpoints;
